<template>
    <kgr-form-scaffold
        :pending="pending"
        :pending-delete="pendingRemove"
        :with-delete-button="isDeletable"
        :with-primary-buttons="isEditable"
        edit-mode
        @primaryBtnClicked="updateDepartment"
        @deleteBtnClicked="removeDepartment"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-department-data-provider
            :department-id="departmentId"
            :callback="onDepartmentLoaded"
        >
            <div class="animated fadeIn">
                <kgr-department-basic-data-form
                    ref="departmentForm"
                    :department-input="department"
                    :club-id="clubId"
                    :error="error"
                    @enter="updateDepartment"
                />
            </div>
        </kgr-department-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import DepartmentDataProvider from '../../components/data-provider/DepartmentDataProvider';
import DepartmentRepository from '../../js/repository/DepartmentRepository';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrDepartmentBasicDataForm from '../../components/departments/DepartmentBasicDataForm';

export default {
    components: {
        KgrDepartmentBasicDataForm,
        'kgr-department-data-provider': DepartmentDataProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        departmentId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            pendingRemove: false,
            error: new Error(),
            department: null,
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onDepartmentLoaded(loadedDepartment) {
            this.department = loadedDepartment;
        },
        removeDepartment() {
            showConfirm(this.$t('confirm'), this.$t('department.delete.confirm', {'department': this.department.name}), () => {
                this.pendingRemove = true;
                DepartmentRepository.remove(this.department)
                    .then(() => {
                        this.error = new Error();
                        this.$notify.success('Abteilung erfolgreich gelöscht', {}, { saveInSession: true });
                        this.redirectToOverview();
                    })
                    .catch(error => {
                        this.handleError(error);
                        this.pendingRemove = false
                    });
            }, 'Ok');
        },
        updateDepartment() {
            if(!this.isEditable) {
                return;
            }
            this.pending = true;

            DepartmentRepository.update(this.department)
                .then(() => {
                    this.pending = false;
                    this.error = new Error();
                    this.$notify.success('saveChanges.success');
                    this.$refs.departmentForm.reload();
                })
                .catch(error => {
                    this.handleError(error);
                    this.pending = false;
                });
        },
        handleError(error) {
            this.error = error;
            this.$notify.error('saveChanges.error');
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
